const DocumentRequestsHeader = ({ onCreate }) => {
    return (
        <>
            {/* Header */}
            <div className="page-header">
                <div>
                    <h1>Document Requests</h1>
                    <p>Create and track client document requests</p>
                </div>

                <button
                    className="primary-btn"
                    onClick={() => onCreate()}
                >
                    + New Request
                </button>
            </div>
        </>
    );
};

export default DocumentRequestsHeader;
